import { StorefrontSliderServiceModule } from './storefrontSlider.service';

export const OpenStorefrontSliderModule = angular
    .module('app.components.storefrontSlider.openStorefrontSliderDirective', [
        StorefrontSliderServiceModule
    ]).directive('openStorefrontSlider', (storefrontSliderService) => {
        return {
            restrict: 'A',
            link: (scope, element) => {
                element.on('click', storefrontSliderService.openSlider);
                scope.$on('$destroy', () => {
                    element.off('click', storefrontSliderService.openSlider);
                });
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/storefrontSlider/openStorefrontSlider.directive.js